import axios, { AxiosInstance } from 'axios';

import { IRepository } from '../shared/interfaces/repositories/repository.interface';
import { FormComponent } from '../components/cheerfypay/form/form.component';
import { createRequest } from './request';

export abstract class Repository implements IRepository {
    public static readonly API_V1 = '/api/v1';

    protected readonly _payRequest: AxiosInstance;

    protected readonly _paymentRequest: AxiosInstance;

    protected readonly _backendRequest: AxiosInstance;

    protected readonly _webhookRequest: AxiosInstance;

    protected readonly _rawBackendRequest: AxiosInstance;

    public constructor() {
        this._payRequest = createRequest({
            headers: {
                Authorization: `Token ${window.__PAY_TOKEN__}`,
            },
        });

        this._paymentRequest = createRequest({
            headers: {
                Authorization: `Token ${FormComponent.getVariable('paymentToken')}`,
            },
            baseURL: `${FormComponent.getVariable('paymentBaseUrl')}`,
        });

        this._webhookRequest = createRequest({
            headers: {
                Authorization: `Token ${FormComponent.getVariable('webhookToken')}`,
            },
            baseURL: `${FormComponent.getVariable('webhookBaseUrl')}`,
        });

        this._backendRequest = createRequest({
            baseURL: FormComponent.getVariable('backendBaseUrl'),
        });

        this._rawBackendRequest = axios.create({
            baseURL: FormComponent.getVariable('backendBaseUrl'),
        });
    }
}
